function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/node_modules/@babel/runtime/helpers/inheritsLoose.js
// module id = 18
// module chunks = 0